import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/confirmationbookicon.svg'


const _withScopeId = n => (_pushScopeId("data-v-329cd74d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "agreement-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "close",
    class: "w-auto"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-title" }, "Are you sure you want to submit?")
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", { 'show d-block': _ctx.visible }]),
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isFormInvalid)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "alert alert-danger",
            innerHTML: _ctx.validationMsg
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.enrollmentType == 0
              ? "Once submitted, you will not be able to make changes to your enrollment information."
              : "You can make changes to your open enrollment up to " +
                _ctx.lastdateToEnroll +
                "."), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn text-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, " CANCEL "),
          _createElementVNode("button", {
            type: "button",
            id: "button-confirm",
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitButton && _ctx.submitButton(...args)))
          }, " SUBMIT ")
        ])
      ])
    ])
  ], 2))
}